import React, { Component } from 'react';

class SpecialCats extends Component
{
    render()
    {
        return (
            <div>

            </div>
        )
    }
}

export default SpecialCats;


// WEBPACK FOOTER //
// ./src/components/Special-cats/Special-cats.js